import { render, staticRenderFns } from "./p5.vue?vue&type=template&id=c6ce08dc&scoped=true&"
import script from "./p5.vue?vue&type=script&lang=js&"
export * from "./p5.vue?vue&type=script&lang=js&"
import style0 from "./p5.vue?vue&type=style&index=0&id=c6ce08dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ce08dc",
  null
  
)

export default component.exports